import React from "react";
import "./Page.css";
import useStore from "../store.js";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import Button from "../components/Button/Button.js";

const Page = (props) => {
  const getLocalized = useStore((state) => state.getLocalized);
  const game = useStore((state) => state.game);
  const isHost = useStore((state) => state.isHost);

  return (
    <div
      className={`Page Downloads${
        props.className ? " " + props.className : ""
      }`}
    >
      <h1>{getLocalized("texts", "Downloads")}</h1>
      <div>
        <BlocksRenderer content={getLocalized("texts", "DownloadsText")} />
      </div>

      {/* <Button onClick={() => console.log("Click")}>
        <BlocksRenderer content={getLocalized("texts","StartButtonText")} />
      </Button> */}

      {getLocalized("game", "Downloads")?.map((download) => {
        // console.log("Download", download);
        const cmsUrl = process.env.REACT_APP_CMS_URL;
        const downloadUrl = `${cmsUrl}${download.File.data.attributes.url}`;
        const mimeType = download.File.data.attributes.mime;
        const fileType = mimeType.split("/")[1].toUpperCase();
        return (
          <div className="downloadBlock">
            <Button
              icon="download"
              className="full"
              onClick={() => window.open(downloadUrl, "_blank")}
            >
              <strong>{`${download?.Filename}`}</strong> {`(${fileType})`}
            </Button>
            {download?.FileDescription && (
              <BlocksRenderer content={download.FileDescription} />
            )}
          </div>
        );
      })}

      {props.children}
    </div>
  );
};

export default Page;
